export const EmailTemplatePublish = () => {
    return (
        <>
            <div style={{ position: "relative", border: "1px solid #F8F9FB", display: "flex", flexDirection: "column", width: "960px", height: "1077px", margin: "0 auto", padding: 0 }}>
                <div style={{ width: "100%", height: "213px", backgroundColor: "#F8F9FB" }}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/login_logo.png"} alt="" style={{ display: "block", margin: "38px auto 0 auto" }} />
                </div>
                <div style={{ padding: "90px 160px", color: "#222", fontFamily: "NotoSansKR-Regular", fontSize: "18px", lineHeight: "26px" }}>
                    Hello Friend,<br />
                    <br />
                    <strong>please click here to reset your password:</strong><br /><br />
                    <a href="/" target="_blank" style={{ color: "#EF3E56", textDecoration: "none" }}>click here</a>
                    <br />
                    <br />
                    This link will expire in 30 minutes. <br />
                    <br />
                    If you have not triggered this password reset yourself or if you do not wish to change your password, please ignore his mail.
                </div>
                <div style={{ position: "absolute", width: "960px", height: "430.1px", bottom: 0, background: `url(${process.env.PUBLIC_URL}/assets/images/bg_email.png) no-repeat top`, backgroundSize: "2216px 562px", backgroundPosition: "-350px 30px" }}></div>
            </div>
        </>
    );
}